import * as React from "react";

import styles from "components/DuoErrorScreen.module.scss";
import imageWave from "images/wave.svg";

export enum DuoErrorType {
  NotLoggedIn,
  PermissionDenied,
  ServerError,
  UnknownError,
}

interface Props {
  error?: unknown;
  errorType: DuoErrorType;
}

const DuoErrorScreen = ({ error, errorType }: Props) => {
  const helloText =
    errorType === DuoErrorType.NotLoggedIn ? "Howdy stranger!" : "Hello there!";

  const errorToComponent = {
    [DuoErrorType.NotLoggedIn]: (
      <p>
        Please sign in on{" "}
        <a
          href="https://www.duolingo.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          duolingo.com
        </a>{" "}
        and return to this page.
      </p>
    ),
    [DuoErrorType.PermissionDenied]: (
      <p>
        It looks like you don&apos;t have permission to view the release
        dashboard. Please sign in on{" "}
        <a
          href="https://www.duolingo.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          duolingo.com
        </a>{" "}
        with a more privileged account and return to this page.
      </p>
    ),
    [DuoErrorType.ServerError]: (
      <p>
        It looks like the Release Dashboard is having some trouble right now.
        Consider posting in{" "}
        <a
          href="https://duolingo.slack.com/archives/CV7F8ED42"
          rel="noopener noreferrer"
          target="_blank"
        >
          #proj-release-dashboard
        </a>
        .
      </p>
    ),
    [DuoErrorType.UnknownError]: (
      <p>
        It looks like something went wrong with your request for dashboard data.
        {error instanceof Error ? ` Error message: ${error.message}` : null}
      </p>
    ),
  };
  const message = errorToComponent[errorType];

  return (
    <section className={styles.wrap}>
      <img alt="" className={styles.duo} src={imageWave} />
      <h1>{helloText}</h1>
      {message}
    </section>
  );
};

export default DuoErrorScreen;
